
import React, { useState } from 'react';
import HeaderProfile from '../../../../components/header_Profile/header_Profile.index';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import CounselingDetails from './CounselingDetails/Counseling-details';
import CreatePackage from './PackageDetails/CreatePackage';
import PatientEducation from './PatientEducation/PatientEducation';
import { ConsumptionDetails } from './ConsumptionDetails';
import { PackageVisit } from '../package.helper';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useCounselingStore } from '../../store';

const PakageDetails: React.FC = () => {
  const { t : tBilling} = useTranslation('billing_config');
  const visibleTabs = [
    { key: 'counseling', label: tBilling('package_tabs.counseling') },
    { key: 'package', label: tBilling('package_tabs.package') },
    { key: 'consumption', label: tBilling('package_tabs.consumption') },
    { key: 'education', label: tBilling('package_tabs.education') },
  ];
  const [tabIndex, setTabIndex] = useState(0);
  const location = useLocation();
  const packageVisit: PackageVisit | undefined = (location.state as { packageVisit?: PackageVisit })?.packageVisit;
  const storedCounselingSessionId = useCounselingStore((state) => state.counselingSessionId);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };



  return (
    <Box data-testid="package-details-container">
      <HeaderProfile />
      <Tabs
        data-testid="package-details-tabs"
        value={tabIndex}
        onChange={handleChange}
        sx={{ mb: 2 }}
        variant="fullWidth"
        TabIndicatorProps={{ style: { backgroundColor: '#E17E61' } }}
      >
        {visibleTabs.map((tab, index) => (
          <Tab
            key={tab.key}
            data-testid={`package-details-tab-${tab.key}`}
            label={tab.label}
            disabled={(tab.key === 'package' || tab.key === 'consumption') && storedCounselingSessionId == null}
            sx={{
              fontFamily: 'Montserrat',
              fontSize: '16px',
              fontWeight: tabIndex === index ? 600 : 500,
              color: tabIndex === index ? '#E17E61' : '#BBBBBB',
              textTransform: 'none',
            }}
          />
        ))}
      </Tabs>
      {/* Render tab content */}
      {visibleTabs[tabIndex].key === 'counseling' && (
        <CounselingDetails />
      )}
      {visibleTabs[tabIndex].key === 'package' && (
        <CreatePackage  patient_procedure={packageVisit?.treatment_advice_id} />
      )}
      {visibleTabs[tabIndex].key === 'consumption' && (
        <ConsumptionDetails />
      )}
      {visibleTabs[tabIndex].key === 'education' && (
        <PatientEducation />
      )}
    </Box>
  );
};
export default PakageDetails;
